






import Component from 'vue-class-component';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorCreateForm from '@/context/sensor/component/form/SensorCreateForm.vue';
import WorkPeriodTemplateForm
  from '@/context/work_period/component/template-form/WorkPeriodTemplateForm.vue';
import { CalculationRequestFormModel } from '@/context/calculation/model/CalculationRequestFormModel';
import { CalculationApi } from '@/context/calculation/api/CalculationApi';
import CalculationRequestForm from '@/context/calculation/components/CalculationRequestForm.vue';

@Component({
  components: {
    CalculationRequestForm,
    WorkPeriodTemplateForm,
    SensorCreateForm
  }
})
export default class CalculationFormContainer extends FormContainer<CalculationRequestFormModel> {
  model: CalculationRequestFormModel = new CalculationRequestFormModel();

  async formApi(): Promise<CalculationRequestFormModel> {
    return await CalculationApi.instance().form<CalculationRequestFormModel>(
      CalculationRequestFormModel,
      this.$route?.params?.id ? { id: this.$route.params.id } : null
    );
  }
}
